module.exports = __webpack_public_path__ + "img/20190702160836345.0548522d.png";